/* PDF */
export const GET_FILESTRANING = "GET_FILESTRANING"
export const GET_FILESTRANING_SUCCESS = "GET_FILESTRANING_SUCCESS"
export const GET_FILESTRANING_FAIL = "GET_FILESTRANING_FAIL"